/*
  HYPE SIDE — DMs de clientes (par do sections/hs-dms.liquid)

  1. As filas só andam quando a secção está no ecrã (classe is-live).
     Computador: animação CSS. Telemóvel: a fila é um scroll horizontal
     a sério que o JS vai avançando; o dedo assume o controlo e, 2,5 s
     depois de largar, a fila volta a andar sozinha a partir dali.
  2. Tocar num cartão abre as mensagens em formato stories: barras de
     progresso, toque à esquerda/direita para recuar/avançar, manter o
     dedo para pausar, deslizar para baixo para fechar. "Conversa
     original" mostra a captura tal como chegou.
*/
(function () {
  'use strict';

  var DURATION = 6000;
  var SPEED = 32; // px/s, o mesmo ritmo da animação CSS
  var mobile = window.matchMedia('(max-width: 749px)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Fila do telemóvel: scroll nativo (dá para arrastar) + avanço automático.
     A fila tem o conjunto de cartões duas vezes (largura w cada). A posição
     anda sempre entre 0,5w e 1,5w e salta w para trás/frente nos limites,
     o que é invisível porque as duas metades são iguais. */
  function swipeRow(section, row) {
    var set = row.querySelector('.hs-dms__set');
    if (!set) return function () {};
    var pos = -1;
    var last = 0;
    var running = false;
    var hold = false;
    var touching = false;
    var timer = 0;

    function w() { return set.offsetWidth; }
    function wrap(x) {
      var s = w();
      if (x >= s * 1.5) return x - s;
      if (x < s * 0.5) return x + s;
      return x;
    }
    function release() {
      clearTimeout(timer);
      timer = setTimeout(function () { hold = false; pos = row.scrollLeft; wake(); }, 2500);
    }
    function grab() { hold = true; clearTimeout(timer); }

    row.addEventListener('touchstart', function () { touching = true; grab(); }, { passive: true });
    row.addEventListener('touchend', function () { touching = false; release(); }, { passive: true });
    row.addEventListener('touchcancel', function () { touching = false; release(); }, { passive: true });
    row.addEventListener('wheel', function () { grab(); release(); }, { passive: true });
    row.addEventListener('scroll', function () {
      if (!hold) return;
      var x = wrap(row.scrollLeft);
      if (x !== row.scrollLeft) row.scrollLeft = x;
      if (!touching) release(); // ainda a deslizar por inércia: conta a partir do fim
    }, { passive: true });

    function frame(t) {
      var on = section.classList.contains('is-live') && mobile.matches && !calm.matches && !document.hidden;
      if (!on) { running = false; return; }
      if (!hold) {
        if (pos < 0) pos = w();
        var dt = last ? Math.min(t - last, 50) : 16;
        pos = wrap(pos + SPEED * dt / 1000);
        row.scrollLeft = pos;
      }
      last = t;
      requestAnimationFrame(frame);
    }
    function wake() {
      if (running) return;
      running = true;
      last = 0;
      if (!hold && pos >= 0) pos = row.scrollLeft;
      requestAnimationFrame(frame);
    }
    return wake;
  }

  function init(section) {
    if (section.__hsDms) return;
    section.__hsDms = true;

    var mobileRow = section.querySelector('.hs-dms__row--all');
    var wakeRow = mobileRow ? swipeRow(section, mobileRow) : function () {};
    if (mobile.addEventListener) mobile.addEventListener('change', wakeRow);
    document.addEventListener('visibilitychange', wakeRow);

    var live = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { section.classList.toggle('is-live', e.isIntersecting); });
      wakeRow();
    });
    live.observe(section);

    var dialog = section.querySelector('.hs-dmv');
    var json = section.querySelector('[data-dms-items]');
    if (!dialog || !json || typeof dialog.showModal !== 'function') return;

    var items;
    try { items = JSON.parse(json.textContent); } catch (e) { return; }
    if (!items.length) return;

    var bars = dialog.querySelector('.hs-dmv__bars');
    var stage = dialog.querySelector('.hs-dmv__stage');
    var photo = dialog.querySelector('.hs-dmv__photo');
    var msgs = dialog.querySelector('.hs-dmv__msgs');
    var orig = dialog.querySelector('.hs-dmv__orig');
    var origImg = orig.querySelector('img');
    var toggle = dialog.querySelector('[data-dmv-orig]');
    var toggleTxt = toggle.querySelector('span');
    var heart = section.querySelector('.hs-dm__react');
    var ava = dialog.querySelector('.hs-dmv__ava');
    var name = dialog.querySelector('.hs-dmv__name');
    var handle = dialog.querySelector('.hs-dmv__handle');

    bars.innerHTML = items.map(function () { return '<span></span>'; }).join('');
    bars.style.setProperty('--t', DURATION + 'ms');

    var current = 0;
    var holdTimer = 0;
    var held = false;
    var originalMode = false; // fica ligado ao passar de mensagem, até tocar em "Voltar à foto"

    // O tempo pára com a conversa original aberta, com o dedo pousado ou com o separador escondido
    function sync() { dialog.classList.toggle('is-paused', originalMode || held || document.hidden); }

    function show(i) {
      current = (i + items.length) % items.length;
      var it = items[current];

      [].forEach.call(bars.children, function (b, k) {
        b.className = k < current ? 'is-done' : '';
      });
      // Reinicia a animação da barra atual
      void bars.offsetWidth;
      bars.children[current].className = 'is-now';

      ava.src = it.a;
      name.textContent = it.n;
      handle.textContent = it.h ? '@' + it.h : 'Mensagem de cliente';

      photo.classList.add('is-loading');
      photo.onload = function () { photo.classList.remove('is-loading'); };
      photo.src = it.p;
      photo.alt = 'Foto enviada por ' + it.n + (it.l ? ': ' + it.l : '');

      msgs.textContent = '';
      if (it.l) {
        var label = document.createElement('span');
        label.className = 'hs-dmv__label';
        label.textContent = it.l;
        msgs.appendChild(label);
      }
      it.m.forEach(function (t, k) {
        var b = document.createElement('span');
        b.className = 'hs-dm__bubble';
        b.style.setProperty('--i', k);
        b.textContent = t;
        if (k === it.m.length - 1 && heart) b.appendChild(heart.cloneNode(true));
        msgs.appendChild(b);
      });

      setOriginal(originalMode);
      // Pré-carrega a seguinte
      var next = items[(current + 1) % items.length];
      new Image().src = originalMode ? next.o : next.p;
    }

    function setOriginal(on) {
      originalMode = on;
      orig.hidden = !on;
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      toggleTxt.textContent = on ? 'Voltar à foto' : 'Conversa original';
      if (on) origImg.src = items[current].o;
      sync();
    }

    function open(i) {
      originalMode = false;
      held = false;
      show(i);
      dialog.showModal();
      section.classList.remove('is-live');
      document.documentElement.style.overflow = 'hidden';
    }

    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      photo.removeAttribute('src');
      section.classList.add('is-live');
      wakeRow();
    });

    section.addEventListener('click', function (e) {
      var card = e.target.closest('[data-dm]');
      if (card && section.contains(card)) open(parseInt(card.getAttribute('data-dm'), 10) || 0);
    });

    bars.addEventListener('animationend', function () {
      if (current === items.length - 1) dialog.close();
      else show(current + 1);
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) { dialog.close(); return; }
      if (e.target.closest('[data-dmv-close]')) { dialog.close(); return; }
      var step = e.target.closest('[data-dmv-step]');
      if (step) { show(current + parseInt(step.getAttribute('data-dmv-step'), 10)); return; }
      if (e.target.closest('[data-dmv-orig]')) { setOriginal(!originalMode); return; }
    });

    // Toque no palco (foto ou conversa original): terço esquerdo recua, resto
    // avança; deslizar para os lados também; manter o dedo pausa
    var startY = 0;
    var startX = 0;
    stage.addEventListener('pointerdown', function (e) {
      startX = e.clientX;
      startY = e.clientY;
      held = false;
      holdTimer = setTimeout(function () { held = true; sync(); }, 220);
    });
    stage.addEventListener('pointerup', function (e) {
      clearTimeout(holdTimer);
      var dy = e.clientY - startY;
      var dx = e.clientX - startX;
      if (dy > 80 && Math.abs(dy) > Math.abs(dx)) { dialog.close(); return; }
      if (held) { held = false; sync(); return; }
      if (Math.abs(dx) > 40) { show(current + (dx < 0 ? 1 : -1)); return; }
      var r = stage.getBoundingClientRect();
      show(current + (e.clientX - r.left < r.width / 3 ? -1 : 1));
    });
    stage.addEventListener('pointercancel', function () { clearTimeout(holdTimer); held = false; sync(); });
    stage.addEventListener('contextmenu', function (e) { e.preventDefault(); });

    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(current + 1);
      else if (e.key === 'ArrowLeft') show(current - 1);
    });

    document.addEventListener('visibilitychange', sync);
  }

  function boot() { document.querySelectorAll('[data-hs-dms]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Editor do tema: a secção volta a ser desenhada ao mudar definições
  document.addEventListener('shopify:section:load', boot);
})();
